import { Component, ViewContainerRef,ViewEncapsulation, OnInit, OnDestroy, Input } from '@angular/core';
import 'rxjs/Rx';
import { AuditReportService } from "./audit-report.service";
import { ActivatedRoute, Router, ParamMap } from '@angular/router';
import { Subscription } from "rxjs/Subscription";
import { LocalStorageService } from "angular-2-local-storage";
import { IMyDpOptions, IMyDateModel } from 'mydatepicker';
import { SearchTableState } from "../search-table-state";
import { Column } from "../column";
import { AlertService } from "../../../services/index";
import { ProgrammeService } from "../../../services/DataServices/programme.service";
import { PageStateService } from "../page-state.service";
import { BaseTableComponent } from "../base-table.component";
import * as FileSaver from "file-saver";
import { PermissionService } from "../../../services/SecurityServices/permission.service";
import { AuditReportEntries } from "./audit-report-entries";

@Component({
    selector: 'audit-report-table',
    template: require('./audit-report-table.html'),
    providers: [AuditReportService, LocalStorageService],
    styles: [require('../table.css')]
})

export class AuditReportTableComponent extends BaseTableComponent implements OnInit, OnDestroy {

    @Input() tableName: string = '';
    @Input() identifier: string = '';

    private searchTableState: SearchTableState;
    private auditReportEntries = new Array<AuditReportEntries>();
    private columns: Array<Column>;
    private busy: Subscription;
    private showFilter: boolean = true;
    private disableExportToExcel: boolean = false;
    private static lastRefreshed: string = 'audit-report-last-refreshed';
    private queryParamsSub: any;
    private dateFormat: string = 'yyyy-mm-dd';
    private displayFilter: boolean = true;
    private datePickerOptions: IMyDpOptions = {
        height: '30px',
        dateFormat: this.dateFormat
    };

    constructor(
        vcRef: ViewContainerRef,
        private auditReportService: AuditReportService,
        private router: Router,
        private alertService: AlertService,
        private programmeService: ProgrammeService,
        private pageStateService: PageStateService,
        private localStorageService: LocalStorageService,
        private permissionService: PermissionService,
        private route: ActivatedRoute
    ) {
        super(localStorageService, auditReportService.searchTableState);
        this.setColumns();
    }

    public goTo(value: number): void {
        if (value <= this.searchTableState.pageCount()) {
            this.searchTableState.pageChange(value);
            this.updateTable();
        }
    }

    ngOnInit() {
        
    }

    ngAfterContentInit() {
        let self: AuditReportTableComponent = this;
        this.disableExportToExcel = !this.permissionService.userHasPermission('Audit_ExportExcel');
        this.searchTableState = this.auditReportService.searchTableState;
        this.searchTableState.tablename = this.tableName;
        this.searchTableState.identifier = this.identifier;
        this.searchTableState.currentPage = this.pageStateService.currentAuditReportPage;
        this.blankPage();
        this.setPageSize('audit-report-page-size');
        this.setLastRefreshed(AuditReportTableComponent.lastRefreshed);

        if (this.searchTableState.identifier != '') {
            this.updateTable();
        }

        if (!this.route.snapshot.url.join('/').includes("audit-report")) {
            self.displayFilter = false;
            self.showFilter = false;
        }
    }

    ngOnDestroy() {
        this.searchTableState.currentPage = this.pageStateService.currentAuditReportPage;
    }

    private setColumns() {
        this.columns = new Array<Column>();
        this.columns.push(new Column('UpdateOrder', 'UpdateOrder'));
        this.columns.push(new Column('Unique Identifier', 'Unique Identifier'));
        this.columns.push(new Column('Action Date', 'CreatedDateUtc'));
        this.columns.push(new Column('Action', 'Action'));
        this.columns.push(new Column('FieldName', 'FieldName'));
        this.columns.push(new Column('OldValue', 'OldValue'));
        this.columns.push(new Column('NewValue', 'NewValue'));
        this.columns.push(new Column('UpdatedBy', 'UpdatedBy'));
    }

    private blankPage() {
        this.auditReportEntries = new Array<AuditReportEntries>();
        this.searchTableState.totalItems = 0;
    }

    private updateTable(): void {
        if (this.searchTableState.updating) {
            return;
        }
        this.searchTableState.updating = true;
        let self: AuditReportTableComponent = this;
        this.busy = this.auditReportService.search().subscribe((message: Array<AuditReportEntries>) => {
            self.auditReportEntries = message;
            self.searchTableState.updating = false;
        }, error => {
            self.alertService.error(error._body);
            self.searchTableState.updating = false;
        });
    }
    
    private exportExcel(): void {
        if (this.searchTableState.updating) {
            return;
        }
        this.searchTableState.updating = true;
        let self: AuditReportTableComponent = this;
        this.auditReportService.exportExcel().subscribe(blob => {
            var fileName = 'AuditReport_' + this.searchTableState.lastRefreshed + '.xlsx';
            self.searchTableState.updating = false;
            let file: Blob = blob.blob();
            FileSaver.saveAs(file, fileName);
            self.alertService.success('File generated successfully.');
            self.searchTableState.updating = false;
        }, error => {
            self.alertService.error(error);
            self.searchTableState.updating = false;
        });
    }

    private refreshTable() {
        if (this.searchTableState.updating) {
            return;
        }
        this.updateLastRefreshed(AuditReportTableComponent.lastRefreshed);
        this.updateTable();
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/admin/audit-report/audit-report-table.component.ts